import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      navbar: {
      home: "Home",
      about: "About Us",
      orders: "Orders",
      contact: "Contact us",
      blog: "Blog",
      loading: "Loading...",
      logout: "Logout",
      login: "Login",
      signup: "Sign Up",
      user: "User",
      userProfile: "User Profile"
    },
    home: {
      heroTitleLine1: "Your favorite flavors,",
      heroTitleLine2: "delivered to your",
      heroTitleLine3: "door.",
      heroSubtitle: "Experience premium dining from the comfort of your home. Discover curated local restaurants and artisanal groceries with white-glove service.",
      searchPlaceholder: "Search products...",
      findFood: "Find Food",
      whyUsTitle: "Delivery, elevated.",
      whyUsSubtitle: "A seamless experience designed to bring the city's best culinary offerings directly to you.",
      curatedChoices: "1. Curated Choices",
      curatedChoicesDesc: "Browse our hand-picked selection of premium local restaurants and artisanal markets.",
      seamlessCheckout: "2. Seamless Checkout",
      seamlessCheckoutDesc: "Enjoy a streamlined ordering process with real-time updates and secure payment options.",
      whiteGloveDelivery: "3. White-Glove Delivery",
      whiteGloveDeliveryDesc: "Experience exceptional service with our dedicated delivery team.",
      exploreCategories: "Explore Categories",
      satisfyCraving: "Satisfy any craving, anytime",
      catPizza: "Pizza",
      catSushi: "Sushi",
      catBurgers: "Burgers",
      catAsian: "Asian",
      catHealthy: "Healthy",
      catDesserts: "Desserts",
      catCoffee: "Coffee",
      premiumSelection: "Premium Selection",
      culinaryExcellence: "Culinary Excellence,",
      delivered: "Delivered.",
      chefsChoiceDesc: "Our \"Chef's Choice\" tier brings exclusive dining experiences to your dining room. We partner with Michelin-starred establishments and local culinary innovators to ensure every bite is extraordinary.",
      check1: "Exclusive menus not available elsewhere.",
      check2: "Specialized thermal packaging preserves integrity.",
      check3: "Priority dispatch for peak freshness.",
      explorePremium: "Explore Premium Options",
      featuredPartner: "Featured Partner",
      trendingNearYou: "Trending near You",
      seeAll: "See all",
      loadingProducts: "Loading products...",
      noProductsYet: "No products yet",
      beTheFirst: "Be the first to add a product!",
      farmFreshBadge: "Fresh & Local",
      farmFreshTitleLine1: "Farm fresh to your",
      farmFreshTitleLine2: "fridge.",
      farmFreshDesc: "Skip the checkout lines. We partner with local farmers markets and premium grocers to deliver high-quality produce, pantry staples, and artisanal goods right to your door in under an hour.",
      organicProducts: "Organic Products",
      freshBakery: "Fresh Bakery",
      wineSpirits: "Wine & Spirits",
      pharmacyEssentials: "Pharmacy Essentials",
      shopGroceries: "Shop Groceries",
      driveSuccessTitle: "Drive your own success.",
      driveSuccessDesc: "Join the CraveDash community. Enjoy flexible hours, competitive earnings, and the satisfaction of connecting people with the food they love.",
      partnerRestaurants: "Partner Restaurants",
      happyCustomers: "Happy Customers",
      avgEarnings: "Avg. Earnings",
      tipsKept: "Tips Kept",
      applyToRide: "Apply to Ride",
      craveDashStandard: "The CraveDash Standard",
      stdCuratedSelection: "Curated Selection",
      stdCuratedDesc: "We only partner with top-rated restaurants to ensure quality.",
      stdQualityGuarantee: "Quality Guarantee",
      stdQualityDesc: "If it's not perfect, we'll make it right. No questions asked.",
      std247Support: "24/7 VIP Support",
      stdSupportDesc: "Real human support available whenever you need assistance.",
      stdWhiteGlove: "White-Glove Delivery",
      stdWhiteGloveDesc: "Professional couriers trained in handling delicate cuisines.",
      commonQuestions: "Common Questions",
      faq1Q: "How accurate are delivery times?",
      faq1A: "Our real-time tracking system provides live ETA updates. Most orders arrive within the quoted window, and our drivers are equipped with route optimization tools.",
      faq2Q: "Are there hidden service fees?",
      faq2A: "No. We display all fees transparently at checkout — delivery fee, service fee, and any applicable taxes — before you confirm your order.",
      faq3Q: "How do I become a restaurant partner?",
      faq3A: "Visit our Partners page and fill in the application form. Our team will reach out within 48 hours to discuss onboarding.",
    },
    card: {
      noImage: "No Image",
      unnamedProduct: "Unnamed Product",
      noDescription: "No description provided for this product.",
      orderNow: "Order Now",
      viewMenu: "View Menu →",
      unknown: "Unknown"
    },
    about: {
      title: "About Us",
      home: "Home",
      smallTitle: "ABOUT US",
      weAlwaysMakeBest: "We Always Make The Best",
      description: "At CraveDash, we believe that culinary excellence should be accessible to everyone. Our mission is to bridge the gap between world-class culinary expertise and your front door, ensuring every meal delivered is a masterpiece of flavor and freshness.",
      contactUs: "Contact Us",
      ourSkills: "Our Skills",
      skillsDescription: "We pride ourselves on our core delivery pillars that ensure every customer experiences the highest level of service in the food technology industry.",
      reliability: "Reliability",
      selection: "Selection",
      speed: "Speed",
      yearsOfExperience: "Year Of Experience",
      partners: "Partners",
      happyCustomers: "Happy Customers",
      certifiedAward: "Certified Award",
      hireUsNow: "HIRE US NOW",
      alwaysReady: "We Are Always Ready To Deliver Excellence",
      getStarted: "Get Started"
    },
    contact: {
      heroTitle: "Let's connect over dinner",
      heroDesc: "Have a question about our delivery areas or want to partner your kitchen with us? We're here to help you crave better.",
      getInTouch: "Get in touch",
      leftDescription: "Sociosqu viverra lectus placerat sem efficitur molestie vehicula cubilia leo etiam nam.",
      headOffice: "Head Office",
      emailUs: "Email Us",
      callUs: "Call Us",
      followSocial: "FOLLOW OUR SOCIAL MEDIA",
      sendMessage: "Send us a message",
      yourName: "Your Name",
      companyName: "Company Name",
      phone: "+62...",
      emailPlaceholder: "email@example.com",
      subjectPlaceholder: "How can we help?",
      messagePlaceholder: "Tell us more about your request...",
      send: "Send",
      hqTitle: "CraveDash HQ",
      district: "CENTRAL JAKARTA DISTRICT",
      openHours: "Open for support: Mon-Fri, 9AM - 6PM",
      getDirections: "Get Directions",
      messageSent: "Message Sent!",
      failed: "Failed..."
    },
    blog: {
      trending: "TRENDING",
      trendingText: "Japanese Unagi Dumplings That Will Leave You Speechless",
      magazine: "Magazine",
      restaurants: "Restaurants",
      offers: "Offers",
      searchStories: "Search stories...",
      createPost: "✍️ Create Post",
      cancel: "✕ Cancel",
      createNewStory: "Create a New Story",
      articleTitle: "Article Title",
      articleTitlePlaceholder: "e.g., The Secret to Perfect Neapolitan Pizza Crust",
      categoryTag: "Category Tag",
      coverImageUrl: "Cover Image URL",
      coverImagePlaceholder: "https://images.unsplash.com/... (Optional)",
      shortSnippet: "Short Snippet Description",
      shortSnippetPlaceholder: "Brief sentence to summarize the story preview on the feed...",
      fullArticleBody: "Full Article Body Content",
      fullArticlePlaceholder: "Write your complete story narrative paragraphs here...",
      publishToFirebase: "🚀 Publish to Firebase",
      categories: "CATEGORIES:",
      latestStories: "Latest Stories",
      loadingPosts: "⏳ Loading posts from Firebase...",
      readMore: "Read More →",
      delete: "🗑️ Delete",
      emptyFeed: "No matching stories found. Click \"Create Post\" to add one!",
      loadMore: "Load More Stories",
      stayConnected: "Stay Connected",
      like: "👤 LIKE",
      follow: "📸 FOLLOW",
      twitterFollow: "🐦 FOLLOW",
      sub: "▶️ SUB",
      dontMiss: "Don't Miss",
      by: "By",
      staff: "Staff",
      failedPublish: "Failed to publish post. Please try again.",
      confirmDelete: "Are you sure you want to delete"
    },
    orders: {
      heroTitleLine1: "Your orders,",
      heroTitleLine2: "all in one place.",
      heroDesc: "Track every delivery in real-time. From the kitchen to your door — full visibility, zero guesswork.",
      searchPlaceholder: "Search your orders…",
      searchBtn: "Search",
      cravingSpecific: "Craving something specific?",
      filterCategory: "Filter your orders by category",
      trendingNow: "Trending Now",
      popularChoices: "Popular choices near you",
      page: "Page",
      of: "of",
      loadingProducts: "Loading products…",
      noProducts: "No products available matching your search or category.",
      yourRecentOrders: "Your Recent Orders",
      noOrdersFound: "No orders found",
      signInToView: "Sign in to view your orders",
      ordersFound: "orders found",
      orderFound: "order found",
      historyAppearHere: "Your order history will appear here once you're logged in.",
      browseMenu: "Browse menu",
      loadingOrders: "Loading your orders…",
      loading: "Loading…",
      pleaseSignIn: "Please sign in to see your orders.",
      signInLink: "sign in",
      noOrdersYet: "No orders yet — start ordering!",
      startOrderingLink: "start ordering",
      craveDashPlus: "CraveDash+",
      get0Delivery: "Get 0€ delivery fee",
      joinCraveDashPlus: "Join CraveDash+ and enjoy unlimited free deliveries on eligible orders.",
      startFreeTrial: "Start free trial",
      statusPending: "Pending",
      statusConfirmed: "Confirmed",
      statusDelivered: "Delivered",
      statusCancelled: "Cancelled",
      order: "Order",
      item: "item",
      restaurant: "Restaurant",
      ourPartners: "Our Premium Partners",
      ourPartnersDesc: "Discover premium kitchens and local restaurants delivering to you",
      noPartnersYet: "No premium partners registered yet."
    },
    singleProduct: {
      backToMenu: "Back to Menu",
      loadingExperience: "Loading your culinary experience...",
      reviews: "reviews",
      freeDelivery: "Free Delivery",
      selectSize: "SELECT SIZE",
      small: "Small",
      medium: "Medium",
      large: "Large",
      customizeBite: "CUSTOMIZE YOUR BITE",
      signInToOrder: "🔒 Sign in to Order",
      ordered: "✓ Ordered!",
      ordering: "Ordering...",
      orderNow: "Order Now - $",
      pairsWellWith: "🍟 Pairs Well With",
      orderFailed: "Order failed:"
    },
    auth: {
      welcomeBack: "WELCOME BACK",
      logInAccount: "Log in to your account",
      dontHaveAccount: "Don't have an account?",
      signUp: "Sign Up",
      email: "Email",
      password: "Password",
      googleSignIn: "Google Sign In",
      logIn: "Log In",
      loggingIn: "Logging in...",
      startForFree: "START FOR FREE",
      createNewAccount: "Create new account",
      alreadyMember: "Already A Member?",
      firstName: "First name",
      lastName: "Last name",
      creating: "Creating...",
      createAccount: "Create account",
      required: "Required",
      invalidEmail: "Invalid email address",
      passwordMin: "Password must be at least 6 characters",
      invalidEmailPass: "Invalid email or password",
      emailInUse: "This email is already registered",
      createCompanyAccount: "Create Company account",
      createCourierAccount: "Create Courier account",
      createUserAccount: "Create User account"
    },
    rating: {
      leaveReview: "Leave a Review",
      modalTitle: "Rate your order",
      rateExperience: "Rate your experience (1-5 stars)",
      commentPlaceholder: "Share your thoughts... (optional)",
      submit: "Submit Review",
      submitting: "Submitting...",
      alreadyReviewed: "You have already reviewed this order.",
      close: "Close"
    },
    error: {
      error404: "Error 404",
      pageNotFound: "Page Not Found",
      errorMessage: "Oops! It looks like you've wandered off the track. The page you are looking for does not exist, has been moved, or is temporarily unavailable.",
      backToHome: "Back to Home",
      goBack: "Go Back"
    },
    footer: {
      contactUs: "Contact Us",
      addressL1: "My Company, 42 Avenue Des Champs",
      addressL2: "Élysées, 75008 Paris, France",
      callUs: "Call us now: 0123-456-789",
      email: "Email: contact@yourcompany.com",
      subscribeToNews: "Subscribe to News",
      emailPlaceholder: "Your E-mail here",
      women: "Women",
      men: "Men",
      lookbook: "Lookbook",
      sale: "Sale",
      blog: "Blog",
      contact: "Contact"
    },
    popupCard: {
      newOrder: "NEW ORDER",
      readyIn: "Ready in",
      pickUpIn: "Pick up in",
      min: "min",
      remove: "Remove",
      acceptOrder: "Accept Order",
      takeDelivery: "Take Delivery",
      noLocation: "No location",
      orderId: "ORDER #"
    },
    dashboard: {
      loading: "Loading…",
      noAccess: "No Access",
      unrecognizedRole: "Unrecognized account role.",
      adminConsole: "AdminConsole",
      mgmtSuite: "Management Suite",
      searchOps: "Search operations…",
      menu: "Menu",
      refreshing: "Refreshing...",
      refreshData: "Refresh Data",
      logout: "Logout",
      navOrderMgmt: "Order Management",
      navSettings: "Settings",
      navDashboard: "Dashboard",
      navPerformance: "Performance",
      navOrders: "Orders",
      navPostProduct: "Post Product",
      navProfit: "Profit",
      unknownUser: "Unknown User"
    },
    notifications: {
      title: "Notifications",
      updates: "Updates",
      mentions: "Mentions",
      markAllRead: "Mark all as read",
      viewAllActivity: "View All Activity",
      secAccountSecurity: "Account Security",
      secAccountSecurityDesc: "New login detected from a Chrome browser on Windows in Seattle, WA.",
      secPromo: "New Promo Available",
      secPromoDesc: "Hungry? Enjoy 30% off your next Italian order. Offer expires tonight!",
      secSub: "Subscription Active",
      secSubDesc: "Dash Pro subscription renewed successfully.",
      secFollower: "New Follower",
      secFollowerDesc: "Sarah Jenkins followed your \"Friday Night Favorites\" list.",
      secOrder: "Order Delivered",
      secOrderDesc: "Your order from \"The Burger Joint\" was delivered."
    },
    companyOrders: {
      title: "Live Orders",
      subtitle: "Manage incoming orders and track preparation in real-time.",
      tabPending: "Pending",
      tabPreparing: "Preparing",
      tabReadyActive: "Ready/Active",
      emptyOrders: "No {{status}} orders.",
      loadingOrders: "Loading orders...",
      liveSync: "Live Syncing",
      customer: "CUSTOMER",
      orderItems: "ORDER ITEMS",
      waitTime: "WAIT TIME",
      total: "TOTAL",
      avgPrepTime: "AVG. PREP TIME",
      dailyRevenue: "DAILY REVENUE",
      totalOrders: "TOTAL ORDERS",
      rating: "MERCHANT RATING",
      urgent: "Urgent",
      acceptBtn: "Accept",
      rejectBtn: "Reject",
      readyBtn: "Ready",
      cancelBtn: "Cancel",
      liveView: "Live View",
      kitchenDisplay: "Kitchen Display"
    }
  },
},
sq: {
  translation: {
    navbar: {
      home: "Kreu",
      about: "Rreth Nesh",
      orders: "Porositë",
      contact: "Na Kontaktoni",
      blog: "Blog",
      loading: "Duke u ngarkuar...",
      logout: "Dil",
      login: "Hyr",
      signup: "Regjistrohu",
      user: "Përdorues",
      userProfile: "Profili i Përdoruesit"
    },
    home: {
      heroTitleLine1: "Shijet tuaja të preferuara,",
      heroTitleLine2: "të dërguara në",
      heroTitleLine3: "derën tuaj.",
      heroSubtitle: "Përjetoni një ngrënie premium nga komoditeti i shtëpisë tuaj. Zbuloni restorante lokale të zgjedhura dhe ushqime artizanale me shërbim të shkëlqyer.",
      searchPlaceholder: "Kërko produkte...",
      findFood: "Gjej Ushqim",
      whyUsTitle: "Dërgesa, e ngritur në nivel.",
      whyUsSubtitle: "Një përvojë e qetë e krijuar për të sjellë ofertat më të mira të kuzhinës së qytetit drejtpërdrejt tek ju.",
      curatedChoices: "1. Zgjedhje të Kuruara",
      curatedChoicesDesc: "Shfletoni përzgjedhjen tonë të zgjedhur me dorë të restoranteve premium lokale dhe tregjeve artizanale.",
      seamlessCheckout: "2. Blerje e Qetë",
      seamlessCheckoutDesc: "Shijoni një proces porositjeje të thjeshtuar me përditësime në kohë reale dhe mundësi pagese të sigurta.",
      whiteGloveDelivery: "3. Shërbim Ekselent i Dërgesës",
      whiteGloveDeliveryDesc: "Përjetoni një shërbim të jashtëzakonshëm me ekipin tonë të dedikuar të dërgesave.",
      exploreCategories: "Eksploro Kategoritë",
      satisfyCraving: "Kënaqni çdo dëshirë, në çdo kohë",
      catPizza: "Pica",
      catSushi: "Sushi",
      catBurgers: "Burger",
      catAsian: "Aziatike",
      catHealthy: "Të Shëndetshme",
      catDesserts: "Ëmbëlsira",
      catCoffee: "Kafe",
      premiumSelection: "Përzgjedhje Premium",
      culinaryExcellence: "Ekselencë në Kuzhinë,",
      delivered: "E Dërguar.",
      chefsChoiceDesc: "Niveli ynë \"Zgjedhja e Shefit\" sjell përvoja ekskluzive të ngrënies në dhomën tuaj të ngrënies. Ne bashkëpunojmë me objekte me yje Michelin dhe novatorë lokalë të kuzhinës për të siguruar që çdo kafshatë të jetë e jashtëzakonshme.",
      check1: "Menu ekskluzive që nuk gjenden gjetkë.",
      check2: "Paketimi termik i specializuar ruan integritetin.",
      check3: "Dërgim me prioritet për freski maksimale.",
      explorePremium: "Eksploro Opsionet Premium",
      featuredPartner: "Partner i Zgjedhur",
      trendingNearYou: "Në trend pranë jush",
      seeAll: "Shiko të gjitha",
      loadingProducts: "Duke ngarkuar produktet...",
      noProductsYet: "Nuk ka produkte ende",
      beTheFirst: "Bëhuni i pari që shton një produkt!",
      farmFreshBadge: "Të Freskëta & Lokale",
      farmFreshTitleLine1: "Të freskëta nga ferma në",
      farmFreshTitleLine2: "frigoriferin tuaj.",
      farmFreshDesc: "Kapërceni radhët e blerjeve. Ne bashkëpunojmë me tregjet e fermerëve lokalë dhe shitësit premium ushqimesh për të ofruar produkte me cilësi të lartë, ushqime bazë dhe mallra artizanale drejt në derën tuaj në më pak se një orë.",
      organicProducts: "Produkte Organike",
      freshBakery: "Furrë e Freskët",
      wineSpirits: "Verëra & Pije alkoolike",
      pharmacyEssentials: "Gjëra Thelbësore Farmacie",
      shopGroceries: "Bli Ushqime",
      driveSuccessTitle: "Drejtoni suksesin tuaj.",
      driveSuccessDesc: "Bashkohuni me komunitetin e CraveDash. Shijoni orare fleksibël, fitime konkurruese dhe kënaqësinë e lidhjes së njerëzve me ushqimin që ata duan.",
      partnerRestaurants: "Restorante Partnere",
      happyCustomers: "Klientë të Kënaqur",
      avgEarnings: "Fitimet Mesatare",
      tipsKept: "Bakshishe të Mbajtura",
      applyToRide: "Aplikoni për të Drejtuar",
      craveDashStandard: "Standardi i CraveDash",
      stdCuratedSelection: "Përzgjedhje e Kuruar",
      stdCuratedDesc: "Ne bashkëpunojmë vetëm me restorante të vlerësuara me nota të larta për të siguruar cilësi.",
      stdQualityGuarantee: "Garanci Cilësie",
      stdQualityDesc: "Nëse nuk është perfekte, ne do ta rregullojmë. Pa pyetje.",
      std247Support: "Mbështetje VIP 24/7",
      stdSupportDesc: "Mbështetje reale njerëzore e disponueshme sa herë që ju nevojitet ndihmë.",
      stdWhiteGlove: "Dërgesë Ekselente",
      stdWhiteGloveDesc: "Korrierë profesionistë të trajnuar në trajtimin e kuzhinave delikate.",
      commonQuestions: "Pyetje të Zakonshme",
      faq1Q: "Sa të sakta janë kohët e dërgesës?",
      faq1A: "Sistemi ynë i gjurmimit në kohë reale siguron përditësime live të ETA. Shumica e porosive mbërrijnë brenda dritares së cituar dhe shoferët tanë janë të pajisur me mjete të optimizimit të rrugës.",
      faq2Q: "A ka tarifa shërbimi të fshehura?",
      faq2A: "Jo. Ne i shfaqim të gjitha tarifat në mënyrë transparente në arkë — tarifat e dërgesës, tarifat e shërbimit dhe çdo taksë e aplikueshme — përpara se të konfirmoni porosinë tuaj.",
      faq3Q: "Si mund të bëhem partner restoranti?",
      faq3A: "Vizitoni faqen tonë të Partnerëve dhe plotësoni formularin e aplikimit. Ekipi ynë do t'ju kontaktojë brenda 48 orëve për të diskutuar regjistrimin.",
    },
    card: {
      noImage: "Asnjë Imazh",
      unnamedProduct: "Produkt i Paemëruar",
      noDescription: "Asnjë përshkrim i ofruar për këtë produkt.",
      orderNow: "Porosit Tani",
      viewMenu: "Shiko Menunë →",
      unknown: "E panjohur"
    },
    about: {
      title: "Rreth Nesh",
      home: "Kreu",
      smallTitle: "RRETH NESH",
      weAlwaysMakeBest: "Ne Gjithmonë Bëjmë Më të Mirën",
      description: "Në CraveDash, ne besojmë se përsosmëria në kuzhinë duhet të jetë e arritshme për të gjithë. Misioni ynë është të mbyllim hendekun midis ekspertizës së kuzhinës së klasit botëror dhe derës suaj, duke siguruar që çdo vakt i dërguar të jetë një kryevepër e shijes dhe freskisë.",
      contactUs: "Na Kontaktoni",
      ourSkills: "Aftësitë Tona",
      skillsDescription: "Ne krenohemi me shtyllat tona kryesore të dërgesës që sigurojnë që çdo klient të përjetojë nivelin më të lartë të shërbimit në industrinë e teknologjisë ushqimore.",
      reliability: "Besueshmëria",
      selection: "Përzgjedhja",
      speed: "Shpejtësia",
      yearsOfExperience: "Vite Përvojë",
      partners: "Partnerë",
      happyCustomers: "Klientë të Kënaqur",
      certifiedAward: "Çmime të Çertifikuara",
      hireUsNow: "NA PUNËSONI TANI",
      alwaysReady: "Ne Jemi Gjithmonë Gati Të Ofrojmë Ekselencë",
      getStarted: "Fillo Tani"
    },
    contact: {
      heroTitle: "Le të lidhemi gjatë darkës",
      heroDesc: "Keni një pyetje rreth zonave tona të dërgesës ose dëshironi të bashkëpunoni me kuzhinën tuaj me ne? Ne jemi këtu për t'ju ndihmuar të dëshironi më mirë.",
      getInTouch: "Të biem në kontakt",
      leftDescription: "Sociosqu viverra lectus placerat sem efficitur molestie vehicula cubilia leo etiam nam.",
      headOffice: "Zyra Qendrore",
      emailUs: "Na Dërgoni Email",
      callUs: "Na Telefononi",
      followSocial: "NDIQNI RRJETET TONA SOCIALE",
      sendMessage: "Na dërgoni një mesazh",
      yourName: "Emri Juaj",
      companyName: "Emri i Kompanisë",
      phone: "+355...",
      emailPlaceholder: "email@example.com",
      subjectPlaceholder: "Si mund t'ju ndihmojmë?",
      messagePlaceholder: "Na tregoni më shumë rreth kërkesës suaj...",
      send: "Dërgo",
      hqTitle: "Zyrat Qendrore të CraveDash",
      district: "QARKU QENDROR I TIRANËS",
      openHours: "Hapur për mbështetje: Hën-Pre, 9AM - 6PM",
      getDirections: "Merrni Udhëzimet",
      messageSent: "Mesazhi u Dërgua!",
      failed: "Dështoi..."
    },
    blog: {
      trending: "NË TREND",
      trendingText: "Dumplings Japoneze Unagi Që Do T'ju Lënë Pa Fjalë",
      magazine: "Revista",
      restaurants: "Restorantet",
      offers: "Ofertat",
      searchStories: "Kërko histori...",
      createPost: "✍️ Krijo Postim",
      cancel: "✕ Anulo",
      createNewStory: "Krijo një Histori të Re",
      articleTitle: "Titulli i Artikullit",
      articleTitlePlaceholder: "p.sh., Sekreti për Korën Perfekte të Picës Napolitane",
      categoryTag: "Etiketa e Kategorisë",
      coverImageUrl: "URL e Imazhit të Kopertinës",
      coverImagePlaceholder: "https://images.unsplash.com/... (Opsionale)",
      shortSnippet: "Përshkrim i Shkurtër",
      shortSnippetPlaceholder: "Fjali e shkurtër për të përmbledhur pamjen paraprake të historisë në burim...",
      fullArticleBody: "Përmbajtja e Plotë e Artikullit",
      fullArticlePlaceholder: "Shkruani paragrafët e plotë të rrëfimit të historisë suaj këtu...",
      publishToFirebase: "🚀 Publiko në Firebase",
      categories: "KATEGORITË:",
      latestStories: "Historitë e Fundit",
      loadingPosts: "⏳ Duke ngarkuar postimet nga Firebase...",
      readMore: "Lexo Më Shumë →",
      delete: "🗑️ Fshi",
      emptyFeed: "Nuk u gjetën histori që përputhen. Klikoni \"Krijo Postim\" për të shtuar një!",
      loadMore: "Ngarko Më Shumë Histori",
      stayConnected: "Qëndro i Lidhur",
      like: "👤 PËLQEJ",
      follow: "📸 NDIQ",
      twitterFollow: "🐦 NDIQ",
      sub: "▶️ ABONOHU",
      dontMiss: "Mos e Humb",
      by: "Nga",
      staff: "Stafi",
      failedPublish: "Publikimi i postimit dështoi. Ju lutemi provoni përsëri.",
      confirmDelete: "A jeni i sigurt që dëshironi të fshini"
    },
    orders: {
      heroTitleLine1: "Porositë tuaja,",
      heroTitleLine2: "të gjitha në një vend.",
      heroDesc: "Ndiqni çdo dërgesë në kohë reale. Nga kuzhina deri në derën tuaj — vizibilitet i plotë, pa hamendësime.",
      searchPlaceholder: "Kërko porositë e tua…",
      searchBtn: "Kërko",
      cravingSpecific: "Po dëshironi diçka specifike?",
      filterCategory: "Filtro porositë e tua sipas kategorisë",
      trendingNow: "Në Trend Tani",
      popularChoices: "Zgjedhjet popullore pranë jush",
      page: "Faqja",
      of: "nga",
      loadingProducts: "Duke ngarkuar produktet…",
      noProducts: "Nuk ka produkte të disponueshme që përputhen me kërkimin ose kategorinë tuaj.",
      yourRecentOrders: "Porositë e tua të Fundit",
      noOrdersFound: "Nuk u gjet asnjë porosi",
      signInToView: "Hyni për të parë porositë tuaja",
      ordersFound: "porosi u gjetën",
      orderFound: "porosi u gjet",
      historyAppearHere: "Historia e porosive tuaja do të shfaqet këtu sapo të hyni.",
      browseMenu: "Shfleto menunë",
      loadingOrders: "Duke ngarkuar porositë e tua…",
      loading: "Duke u ngarkuar…",
      pleaseSignIn: "Ju lutemi hyni për të parë porositë tuaja.",
      signInLink: "hyni",
      noOrdersYet: "Nuk ka porosi ende — filloni të porosisni!",
      startOrderingLink: "filloni të porosisni",
      craveDashPlus: "CraveDash+",
      get0Delivery: "Merrni tarifë dërgese 0€",
      joinCraveDashPlus: "Bashkohuni me CraveDash+ dhe shijoni dërgesa të pakufizuara falas në porositë e pranueshme.",
      startFreeTrial: "Fillo provën falas",
      statusPending: "Në Pritje",
      statusConfirmed: "E Konfirmuar",
      statusDelivered: "E Dërguar",
      statusCancelled: "E Anuluar",
      order: "Porosia",
      item: "artikull",
      restaurant: "Restoranti",
      ourPartners: "Partnerët Tanë Premium",
      ourPartnersDesc: "Zbuloni kuzhinat premium dhe restorantet lokale që ju shërbejnë",
      noPartnersYet: "Nuk ka partnerë premium të regjistruar ende."
    },
    singleProduct: {
      backToMenu: "Kthehu te Menuja",
      loadingExperience: "Duke ngarkuar përvojën tuaj të kuzhinës...",
      reviews: "vlerësime",
      freeDelivery: "Dërgesë Falas",
      selectSize: "ZGJIDH MADHËSINË",
      small: "E Vogël",
      medium: "E Mesme",
      large: "E Madhe",
      customizeBite: "PËRSHTATNI KAFSHATËN TUAJ",
      signInToOrder: "🔒 Hyni për të Porositur",
      ordered: "✓ E Porositur!",
      ordering: "Duke Porositur...",
      orderNow: "Porosit Tani - $",
      pairsWellWith: "🍟 Përshtatet Mirë Me",
      orderFailed: "Porosia dështoi:"
    },
    auth: {
      welcomeBack: "MIRËSEUGJETËM",
      logInAccount: "Hyni në llogarinë tuaj",
      dontHaveAccount: "Nuk keni një llogari?",
      signUp: "Regjistrohu",
      email: "Emaili",
      password: "Fjalëkalimi",
      googleSignIn: "Hyr me Google",
      logIn: "Hyr",
      loggingIn: "Duke hyrë...",
      startForFree: "FILLO FALAS",
      createNewAccount: "Krijo llogari të re",
      alreadyMember: "Tashmë jeni Anëtar?",
      firstName: "Emri",
      lastName: "Mbiemri",
      creating: "Duke krijuar...",
      createAccount: "Krijo llogarinë",
      required: "E detyrueshme",
      invalidEmail: "Adresë emaili e pavlefshme",
      passwordMin: "Fjalëkalimi duhet të jetë të paktën 6 karaktere",
      invalidEmailPass: "Email ose fjalëkalim i pavlefshëm",
      emailInUse: "Kjo adresë emaili është e regjistruar tashmë",
      createCompanyAccount: "Krijo llogari Kompanie",
      createCourierAccount: "Krijo llogari Korrieri",
      createUserAccount: "Krijo llogari Përdoruesi"
    },
    rating: {
      leaveReview: "Lini një Vlerësim",
      modalTitle: "Vlerësoni porosinë tuaj",
      rateExperience: "Vlerësoni përvojën tuaj (1-5 yje)",
      commentPlaceholder: "Ndani mendimet tuaja... (opsionale)",
      submit: "Dërgo Vlerësimin",
      submitting: "Duke u dërguar...",
      alreadyReviewed: "Ju e keni vlerësuar tashmë këtë porosi.",
      close: "Mbyll"
    },
    error: {
      error404: "Gabimi 404",
      pageNotFound: "Faqja Nuk u Gjet",
      errorMessage: "Ups! Duket se keni dalë nga rruga. Faqja që po kërkoni nuk ekziston, është zhvendosur ose është përkohësisht e padisponueshme.",
      backToHome: "Kthehu në Kreu",
      goBack: "Kthehu Prapa"
    },
    footer: {
      contactUs: "Na Kontaktoni",
      addressL1: "Kompania Ime, Rruga e Kavajës",
      addressL2: "Tiranë, 1001, Shqipëri",
      callUs: "Na telefononi tani: 0123-456-789",
      email: "Email: kontakt@kompaniajuaj.com",
      subscribeToNews: "Abonohuni te të Rejat",
      emailPlaceholder: "E-maili juaj këtu",
      women: "Gra",
      men: "Burra",
      lookbook: "Libër Pamjesh",
      sale: "Shitje",
      blog: "Blog",
      contact: "Kontakt"
    },
    popupCard: {
      newOrder: "POROSI E RE",
      readyIn: "Gati për",
      pickUpIn: "Merrni pas",
      min: "min",
      remove: "Hiq",
      acceptOrder: "Prano Porosinë",
      takeDelivery: "Merr Dërgesën",
      noLocation: "Nuk ka vendndodhje",
      orderId: "POROSIA #"
    },
    dashboard: {
      loading: "Duke u ngarkuar…",
      noAccess: "Nuk Keni Qasje",
      unrecognizedRole: "Roli i llogarisë nuk njihet.",
      adminConsole: "KonsolaAdmin",
      mgmtSuite: "Suița e Menaxhimit",
      searchOps: "Kërko operacionet…",
      menu: "Menuja",
      refreshing: "Duke u rifreskuar...",
      refreshData: "Rifresko të Dhënat",
      logout: "Dil",
      navOrderMgmt: "Menaxhimi i Porosive",
      navSettings: "Cilësimet",
      navDashboard: "Paneli",
      navPerformance: "Performanca",
      navOrders: "Porositë",
      navPostProduct: "Posto Produkt",
      navProfit: "Fitimi",
      unknownUser: "Përdorues i Panjohur"
    },
    notifications: {
      title: "Njoftimet",
      updates: "Përditësimet",
      mentions: "Përmendjet",
      markAllRead: "Shënoj të gjitha si të lexuara",
      viewAllActivity: "Shiko të Gjithë Aktivitetin",
      secAccountSecurity: "Siguria e Llogarisë",
      secAccountSecurityDesc: "Një hyrje e re u zbulua nga një shfletues Chrome në Windows në Tiranë.",
      secPromo: "Ofertë e Re e Disponueshme",
      secPromoDesc: "Të uritur? Shijoni 30% zbritje në porosinë tuaj të ardhshme italiane. Oferta skadon sonte!",
      secSub: "Abonimi Aktiv",
      secSubDesc: "Abonimi Dash Pro u rinovua me sukses.",
      secFollower: "Ndjekës i Ri",
      secFollowerDesc: "Sarah Jenkins ndoqi listën tuaj \"Të Preferuarat e Së Premtes Mbrëma\".",
      secOrder: "Porosia u Dërgua",
      secOrderDesc: "Porosia juaj nga \"The Burger Joint\" u dërgua."
    },
    companyOrders: {
      title: "Porositë Live",
      subtitle: "Menaxhoni porositë hyrëse dhe ndiqni përgatitjen në kohë reale.",
      tabPending: "Në pritje",
      tabPreparing: "Duke u përgatitur",
      tabReadyActive: "Gati/Aktive",
      emptyOrders: "Nuk ka porosi {{status}}.",
      loadingOrders: "Duke ngarkuar porositë...",
      liveSync: "Sinkronizim Live",
      customer: "KLIENTI",
      orderItems: "ARTIKUJT E POROSISË",
      waitTime: "KOHA E PRITJES",
      total: "TOTALI",
      avgPrepTime: "KOHA MES. E PËRGATITJES",
      dailyRevenue: "TË ARDHURAT DITORE",
      totalOrders: "POROSITË TOTAL",
      rating: "VLERËSIMI I SHITËSIT",
      urgent: "Urgjente",
      acceptBtn: "Prano",
      rejectBtn: "Refuzo",
      readyBtn: "Gati",
      cancelBtn: "Anulo",
      liveView: "Pamja Live",
      kitchenDisplay: "Ekrani i Kuzhinës"
    }
  }
}
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
